import {createAsyncThunk, createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RECEIVE_ACTION_TYPE} from "types/enums/receive-action-type";

type State = {
  actionType: RECEIVE_ACTION_TYPE;
  dataPassing: any;
  reloadListCard: boolean;
  anh: any;
  selected: boolean;
  record: any;
  idPhieuKham: number | string;
};

const initialState: State = {
  actionType: RECEIVE_ACTION_TYPE.NORMAL,
  dataPassing: null,
  idPhieuKham: null,
  reloadListCard: false,
  anh: null,
  selected: false,
  record: null,
};

export const reloadAction = createAsyncThunk(
  "data/reloadAction",
  async (_, {dispatch}) => {
    // Chờ 5 giây trước khi thực hiện fetchDataApi

    try {
      dispatch(
        setAction({
          actionType: RECEIVE_ACTION_TYPE.RELOAD,
          dataPassing: null,
        })
      );
      // doi 5s
      await new Promise(resolve => setTimeout(resolve, 1000));
    } catch (error) {
      // Xử lý lỗi nếu cần
    }
  }
);

export const searchPatientSlice = createSlice({
  name: "searchPatient",
  initialState: initialState,
  reducers: {
    setPatientRecord: (state = initialState, action: PayloadAction<any>) => {
      return {
        ...state,
        selected: action.payload.selected,
        record: action.payload.record,
      };
    },
    setActionType: (state = initialState, action: PayloadAction<any>) => {
      return {...state, actionType: action.payload};
    },
    setDataPassing: (state = initialState, action: PayloadAction<any>) => {
      return {...state, dataPassing: action.payload};
    },
    setAction: (state = initialState, action: PayloadAction<any>) => {
      return {
        ...state,
        actionType: action.payload.actionType,
        dataPassing: action.payload.dataPassing,
      };
    },
    setIdPhieuKham: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        idPhieuKham: actions.payload,
      };
    },
    setReloadListCard: (state = initialState, action: PayloadAction<any>) => {
      return {...state, reloadListCard: action.payload};
    },
    setAnh: (state = initialState, action: PayloadAction<any>) => {
      return {...state, anh: action.payload};
    },
  },
});

export const {
  setActionType,
  setDataPassing,
  setAction,
  setReloadListCard,
  setAnh,
  setPatientRecord,
  setIdPhieuKham,
} = searchPatientSlice.actions;

export default searchPatientSlice.reducer;
